// Comprehensive NYC Zip Codes by Borough with Neighborhoods
export const nycZipCodes = {
  manhattan: [
    { zip: '10001', area: 'Chelsea' },
    { zip: '10002', area: 'Lower East Side' },
    { zip: '10003', area: 'East Village, Gramercy' },
    { zip: '10004', area: 'Financial District' },
    { zip: '10005', area: 'Financial District' },
    { zip: '10006', area: 'Tribeca' },
    { zip: '10007', area: 'Tribeca, Civic Center' },
    { zip: '10009', area: 'East Village, Alphabet City' },
    { zip: '10010', area: 'Gramercy, Flatiron' },
    { zip: '10011', area: 'West Village, Chelsea' },
    { zip: '10012', area: 'SoHo, NoLita' },
    { zip: '10013', area: 'Tribeca, Chinatown' },
    { zip: '10014', area: 'West Village, Meatpacking' },
    { zip: '10016', area: 'Gramercy, Murray Hill' },
    { zip: '10017', area: 'Midtown East, Murray Hill' },
    { zip: '10018', area: 'Midtown West, Chelsea' },
    { zip: '10019', area: 'Midtown West, Hell\'s Kitchen' },
    { zip: '10020', area: 'Midtown, Rockefeller Center' },
    { zip: '10021', area: 'Upper East Side' },
    { zip: '10022', area: 'Midtown East' },
    { zip: '10023', area: 'Upper West Side' },
    { zip: '10024', area: 'Upper West Side' },
    { zip: '10025', area: 'Upper West Side, Morningside Heights' },
    { zip: '10026', area: 'Harlem, Morningside Heights' },
    { zip: '10027', area: 'Harlem, Morningside Heights' },
    { zip: '10028', area: 'Upper East Side, Yorkville' },
    { zip: '10029', area: 'East Harlem, Spanish Harlem' },
    { zip: '10030', area: 'Harlem' },
    { zip: '10031', area: 'Hamilton Heights, Harlem' },
    { zip: '10032', area: 'Washington Heights' },
    { zip: '10033', area: 'Washington Heights, Hudson Heights' },
    { zip: '10034', area: 'Inwood, Washington Heights' },
    { zip: '10035', area: 'East Harlem' },
    { zip: '10036', area: 'Midtown West, Times Square, Hell\'s Kitchen' },
    { zip: '10037', area: 'Harlem' },
    { zip: '10038', area: 'Financial District, Chinatown' },
    { zip: '10039', area: 'Harlem' },
    { zip: '10040', area: 'Washington Heights, Inwood' },
    { zip: '10044', area: 'Roosevelt Island' },
    { zip: '10065', area: 'Upper East Side' },
    { zip: '10069', area: 'Upper West Side' },
    { zip: '10075', area: 'Upper East Side' },
    { zip: '10128', area: 'Upper East Side, East Harlem' },
    { zip: '10280', area: 'Battery Park City' },
    { zip: '10282', area: 'Battery Park City' }
  ],
  brooklyn: [
    { zip: '11201', area: 'Brooklyn Heights, Downtown Brooklyn' },
    { zip: '11203', area: 'East Flatbush' },
    { zip: '11204', area: 'Bensonhurst, Mapleton' },
    { zip: '11205', area: 'Fort Greene, Clinton Hill' },
    { zip: '11206', area: 'Williamsburg, East Williamsburg' },
    { zip: '11207', area: 'East New York' },
    { zip: '11208', area: 'East New York, Cypress Hills' },
    { zip: '11209', area: 'Bay Ridge, Fort Hamilton' },
    { zip: '11210', area: 'Flatlands, Midwood' },
    { zip: '11211', area: 'Williamsburg, Greenpoint' },
    { zip: '11212', area: 'Brownsville' },
    { zip: '11213', area: 'Crown Heights' },
    { zip: '11214', area: 'Bensonhurst, Bath Beach' },
    { zip: '11215', area: 'Park Slope, Windsor Terrace' },
    { zip: '11216', area: 'Bedford-Stuyvesant, Crown Heights' },
    { zip: '11217', area: 'Park Slope, Boerum Hill' },
    { zip: '11218', area: 'Kensington, Windsor Terrace' },
    { zip: '11219', area: 'Borough Park' },
    { zip: '11220', area: 'Sunset Park' },
    { zip: '11221', area: 'Bedford-Stuyvesant, Bushwick' },
    { zip: '11222', area: 'Greenpoint' },
    { zip: '11223', area: 'Gravesend, Homecrest' },
    { zip: '11224', area: 'Coney Island' },
    { zip: '11225', area: 'Crown Heights, Prospect Heights' },
    { zip: '11226', area: 'Flatbush, East Flatbush' },
    { zip: '11228', area: 'Dyker Heights, Bath Beach' },
    { zip: '11229', area: 'Gravesend, Homecrest, Midwood' },
    { zip: '11230', area: 'Midwood, Madison' },
    { zip: '11231', area: 'Red Hook, Carroll Gardens' },
    { zip: '11232', area: 'Sunset Park, Industry City' },
    { zip: '11233', area: 'Crown Heights, Ocean Hill' },
    { zip: '11234', area: 'Marine Park, Flatlands, Mill Basin' },
    { zip: '11235', area: 'Brighton Beach, Sheepshead Bay' },
    { zip: '11236', area: 'Canarsie, Mill Basin' },
    { zip: '11237', area: 'Bushwick, East Williamsburg' },
    { zip: '11238', area: 'Prospect Heights, Crown Heights' },
    { zip: '11239', area: 'East New York' },
    { zip: '11249', area: 'Williamsburg' }
  ],
  queens: [
    { zip: '11004', area: 'Glen Oaks, Floral Park' },
    { zip: '11101', area: 'Long Island City, Hunters Point' },
    { zip: '11102', area: 'Astoria, Ditmars' },
    { zip: '11103', area: 'Astoria' },
    { zip: '11104', area: 'Sunnyside' },
    { zip: '11105', area: 'Astoria' },
    { zip: '11106', area: 'Astoria' },
    { zip: '11354', area: 'Flushing' },
    { zip: '11355', area: 'Flushing, Murray Hill' },
    { zip: '11356', area: 'College Point' },
    { zip: '11357', area: 'Whitestone, Beechhurst' },
    { zip: '11358', area: 'Auburndale, Murray Hill' },
    { zip: '11360', area: 'Bayside' },
    { zip: '11361', area: 'Bayside, Oakland Gardens' },
    { zip: '11362', area: 'Little Neck, Douglaston' },
    { zip: '11363', area: 'Little Neck' },
    { zip: '11364', area: 'Oakland Gardens' },
    { zip: '11365', area: 'Fresh Meadows' },
    { zip: '11366', area: 'Fresh Meadows' },
    { zip: '11367', area: 'Kew Gardens Hills' },
    { zip: '11368', area: 'Corona, LeFrak City' },
    { zip: '11369', area: 'East Elmhurst' },
    { zip: '11370', area: 'East Elmhurst' },
    { zip: '11372', area: 'Jackson Heights' },
    { zip: '11373', area: 'Elmhurst' },
    { zip: '11374', area: 'Rego Park' },
    { zip: '11375', area: 'Forest Hills' },
    { zip: '11377', area: 'Woodside, Sunnyside' },
    { zip: '11378', area: 'Maspeth' },
    { zip: '11379', area: 'Middle Village' },
    { zip: '11385', area: 'Ridgewood, Glendale' },
    { zip: '11411', area: 'Cambria Heights' },
    { zip: '11412', area: 'St. Albans' },
    { zip: '11413', area: 'Springfield Gardens, Laurelton' },
    { zip: '11414', area: 'Howard Beach' },
    { zip: '11415', area: 'Kew Gardens' },
    { zip: '11416', area: 'Ozone Park' },
    { zip: '11417', area: 'Ozone Park' },
    { zip: '11418', area: 'Richmond Hill' },
    { zip: '11419', area: 'South Richmond Hill' },
    { zip: '11420', area: 'South Ozone Park' },
    { zip: '11421', area: 'Woodhaven' },
    { zip: '11422', area: 'Rosedale' },
    { zip: '11423', area: 'Hollis' },
    { zip: '11426', area: 'Bellerose' },
    { zip: '11427', area: 'Queens Village' },
    { zip: '11428', area: 'Queens Village' },
    { zip: '11429', area: 'Queens Village' },
    { zip: '11432', area: 'Jamaica' },
    { zip: '11433', area: 'Jamaica, South Jamaica' },
    { zip: '11434', area: 'Jamaica, JFK Airport' },
    { zip: '11435', area: 'Jamaica, Briarwood' },
    { zip: '11436', area: 'South Jamaica' },
    { zip: '11691', area: 'Far Rockaway' },
    { zip: '11692', area: 'Arverne, Edgemere' },
    { zip: '11693', area: 'Far Rockaway' },
    { zip: '11694', area: 'Rockaway Park, Belle Harbor' },
    { zip: '11697', area: 'Breezy Point' }
  ],
  bronx: [
    { zip: '10451', area: 'Concourse, Yankee Stadium' },
    { zip: '10452', area: 'Highbridge, Morris Heights' },
    { zip: '10453', area: 'Morris Heights, University Heights' },
    { zip: '10454', area: 'Mott Haven, Port Morris' },
    { zip: '10455', area: 'Mott Haven, Melrose' },
    { zip: '10456', area: 'Morrisania' },
    { zip: '10457', area: 'Tremont, Mount Hope' },
    { zip: '10458', area: 'Fordham, Belmont' },
    { zip: '10459', area: 'Morrisania, Melrose' },
    { zip: '10460', area: 'West Farms, Crotona Park' },
    { zip: '10461', area: 'Westchester Square, Country Club' },
    { zip: '10462', area: 'Parkchester, Unionport' },
    { zip: '10463', area: 'Riverdale, Kingsbridge' },
    { zip: '10464', area: 'City Island' },
    { zip: '10465', area: 'Throggs Neck, Country Club' },
    { zip: '10466', area: 'Wakefield, Eastchester' },
    { zip: '10467', area: 'Norwood, Bedford Park' },
    { zip: '10468', area: 'Fordham, Kingsbridge' },
    { zip: '10469', area: 'Baychester, Co-op City' },
    { zip: '10470', area: 'Wakefield, Woodlawn' },
    { zip: '10471', area: 'Riverdale, Fieldston' },
    { zip: '10472', area: 'Soundview, Clason Point' },
    { zip: '10473', area: 'Soundview, Hunts Point' },
    { zip: '10474', area: 'Hunts Point' },
    { zip: '10475', area: 'Co-op City, Baychester' }
  ],
  statenIsland: [
    { zip: '10301', area: 'St. George, New Brighton' },
    { zip: '10302', area: 'Port Richmond, Elm Park' },
    { zip: '10303', area: 'Mariner\'s Harbor, Port Richmond' },
    { zip: '10304', area: 'Stapleton, Clifton' },
    { zip: '10305', area: 'Arrochar, South Beach' },
    { zip: '10306', area: 'New Dorp, Oakwood' },
    { zip: '10307', area: 'Tottenville, Charleston' },
    { zip: '10308', area: 'Great Kills, Eltingville' },
    { zip: '10309', area: 'Pleasant Plains, Prince\'s Bay' },
    { zip: '10310', area: 'West Brighton, Grymes Hill' },
    { zip: '10312', area: 'Annadale, Eltingville' },
    { zip: '10314', area: 'Bloomfield, Bulls Head' }
  ]
};

// Generate comprehensive location keywords
export const generateLocationKeywords = () => {
  const allZips = [
    ...nycZipCodes.manhattan,
    ...nycZipCodes.brooklyn,
    ...nycZipCodes.queens,
    ...nycZipCodes.bronx,
    ...nycZipCodes.statenIsland
  ];

  return allZips.map(loc => ({
    zip: loc.zip,
    area: loc.area,
    keywords: [
      `pest control ${loc.area}`,
      `exterminator ${loc.area}`,
      `pest control ${loc.zip}`,
      `bed bug treatment ${loc.area}`,
      `rodent control ${loc.area}`,
      `exterminator near ${loc.area}`
    ]
  }));
};

// Get all ZIP codes as comma-separated string
export const getAllZipsString = () => {
  const allZips = [
    ...nycZipCodes.manhattan,
    ...nycZipCodes.brooklyn,
    ...nycZipCodes.queens,
    ...nycZipCodes.bronx,
    ...nycZipCodes.statenIsland
  ];
  return allZips.map(loc => loc.zip).join(', ');
};

// Get all neighborhoods as comma-separated string
export const getAllNeighborhoodsString = () => {
  const allZips = [
    ...nycZipCodes.manhattan,
    ...nycZipCodes.brooklyn,
    ...nycZipCodes.queens,
    ...nycZipCodes.bronx,
    ...nycZipCodes.statenIsland
  ];
  return allZips.map(loc => loc.area).join(', ');
};
